export const projects = [
  {
    slug: "weather-app",
    title: "Weather App",
    subtitle: "Real-time weather search with forecast and clean UI",
    image: "/images/weather.png",
    tech: ["React", "JavaScript", "API", "CSS", "Bootstrap"],
    features: [
      "City-based real-time weather search",
      "Multi-day forecast with visual indicators",
      "Responsive layout for mobile and desktop",
      " Loading states and basic error handling",
    ],
    learned: [
      "Working with external APIs and handling async data",
      "Managing loading and error states in React",
      "Structuring reusable components",
      "Improving UX for mobile and desktop users",
    ],
    live: "https://your-weather-app.netlify.app",
    github: "https://github.com/Chichiprecious1/chichis-weather",
    problem:
      "Users need quick access to accurate weather data without navigating complex or cluttered interfaces, especially on mobile devices.",
    solution:
      "I built a responsive React application that fetches real-time weather data from an external API and presents it in a clean, readable layout optimized for both desktop and mobile users.",
  },
  {
    slug: "dictionary-app",
    title: "Dictionary App",
    subtitle: "Word search experience with definitions and examples",
    image: "/images/dictionary.png",
    tech: ["React", "API", "CSS"],
    features: [
      "Search words and display definitions instantly",
      "Clean typography and spacing for readability",
      "Responsive UI and structured results layout",
    ],
    live: "https://tshilidzis-dictionary.netlify.app/",
    github: "https://github.com/Chichiprecious1/tshilidzis-dictionary",
    problem:
      "People want fast definitions and examples without navigating multiple pages.",
    solution:
      "Created a React-based dictionary UI that fetches results from an API and displays them in a clean, readable structure.",
  },
  {
    slug: "poem-generator",
    title: "Poem Generator",
    subtitle: "Creative text generator with user input and dynamic output",
    image: "/images/poem.png",
    tech: ["JavaScript", "React", "Logic", "CSS"],
    features: [
      "Generates poems dynamically based on user input",
      "Clean and minimal interface focused on readability",
      "Demonstrates logic, condition handling, and string manipulation",
      "Responsive layout for mobile and desktop",
    ],
    live: "https://mycreationshub.org/",
    github: "https://github.com/Chichiprecious1/South-African-poem-generator",
    problem:
      "Many creative tools are overcomplicated and distract from the content itself.",
    solution:
      "Built a simple, elegant poem generator that focuses on creativity, logic, and user experience.",
  },
  {
    slug: "travel-landing-page",
    title: "Travel Landing Page",
    subtitle:
      "Responsive travel website highlighting destinations and experiences",
    image: "/images/maldives.png",
    tech: ["HTML", "CSS", "Responsive Design"],
    features: [
      "Hero section with strong visual hierarchy",
      "Clean, modern layout focused on travel inspiration",
      "Responsive design optimized for all screen sizes",
      "Clear call-to-action to guide user interaction",
    ],
    live: "https://my-travel-project-maldives.netlify.app",
    github: "https://github.com/Chichiprecious1/My-Travel-Project",
    problem:
      "Travel websites need to quickly capture attention while remaining clean and easy to navigate.",
    solution:
      "Designed a responsive travel landing page that combines strong visuals, clear layout structure, and modern UI principles.",
  },
];
